import classNames from "classnames";

import { DComponent } from "../../../DComponent";
import { GLOBAL_CONSTANTS } from "../../../../global/constants";
import PhoneNumber from "../../../PhoneNumber";
import { EVENTS, listenEvent } from "../../../../utils/event";
import { DEFAULT_COUNTRY } from "../../../../utils/constant";
import { DCStatic } from "../../../../models/DCStatic";

export default class AuthPhoneNumber extends DComponent {
  constructor({
    parent,
    id,
    onSubmit = () => { },
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("AuthPhoneNumber", {

      }),
    });
    this.onSubmit = onSubmit;
    /** @type {PhoneNumber}*/
    this.phoneNumber = undefined;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "AuthPhoneNumber");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.phoneNumber = new PhoneNumber({
      parent: $(".input-list", this.element),
      label: "contactus_phoneNumber",
      invalid: "login_phoneValidate",
      inline: false,
      isRequired: true,
    })

    this.setCountryCode(DCStatic.ipCountry);
    this.addEvent();

    listenEvent(EVENTS.CHANGE_IP_COUNTRY, (data) => this.setCountryCode(data));
  }

  addEvent() {
    $(".btn.continue", this.element).on("click", (e) => {
      e.preventDefault();
      if (this.phoneNumber.isValidate()) {
        typeof this.onSubmit === "function" && this.onSubmit(this.getIdentity());
      }
    })
  }

  onError(error) {
    $(".message", this.element).text(error && error.message ? error.message : GLOBAL_CONSTANTS.DEFAULT_ERROR);
    $(".message", this.element).addClass("error");
    this.setLoading(false);
  }

  onSuccess(data) {
    this.setLoading(false);
    this.phoneNumber.setNumber("");
  }


  setLoading(isLoading) {
    $(".btn.continue", this.element).toggleClass("loading", isLoading);
  }

  setCountryCode(code) {
    try {
      this.phoneNumber.setCountry(code);
    } catch (error) {
      this.phoneNumber.setCountry(DEFAULT_COUNTRY);
    }
  }

  getIdentity() {
    return this.phoneNumber.getNumber();
  }

  focus() {
    $("input", this.element).focus();
  }
}